module.exports = __webpack_public_path__ + "img/41.cbf6e194.jpg";